export enum Errors {
  DEFAULT = 'We are facing some issue. Please try again later.',
  INVALID = "Uh-oh, we couln't process your request.",
  NETWORK = 'We are having trouble connecting to the server. Please ensure you are connected to internet and try again.',
}

export enum ScreenState {
  DEFAULT,
  ERROR,
  LOADING,
  SUCCESS_WITH_DATA,
  SUCCESS_WITH_NO_DATA,
}

export enum POST_RECCO_STEPS {
  LANDING = 'landing',
  POST = 'post',
  VERIFY = 'verify',
  DOWNLOAD_SCREEN = 'download'
}

export enum Tab {
  Creds = 'Creds',
  Overview = 'Overview',
  Reccos = 'Reccos',
}
